/**
 * BENGglas-catalogus — dunne re-export uit @glastotaal/core (één bron voor client én
 * server). Data komt exact uit BENGglas_Productcatalogus.xlsx; zie packages/core/src/
 * articles/benglas.ts. Verkoop = inkoop × (1 + admin-marge), zie useBengMarginPct().
 */
export {
  BENG_LINES,
  BENG_PRODUCTS,
  BENG_INNER_PANE,
  BENG_SPACERS,
  BENG_SPACER_DEFAULT,
  BENG_RW_DB,
  BENG_TEGENRUIT_MM,
  BENG_MIN_W,
  BENG_MIN_H,
  BENG_MIN_AREA_M2,
  BENG_SHAPE_SURCHARGE,
  BENG_SAMPLE_CENTS,
  BENG_TRANSPORT_MAX_SIDE_MM,
  bengBladeMm,
  bengComposition,
  bengHalfTempered,
  bengHybridAvailable,
  bengHybridLaminated,
  bengInnerPaneLabel,
  bengSpacerLabel,
  bengSpacerShort,
  bengMaxSize,
  bengTransportOnRequest,
  bengWeightKgM2,
  bengSellCents,
  bengSpecsFor,
  bengProductsForLine,
  getBengProduct,
  type BengCompositionKind,
  type BengLine,
  type BengLineInfo,
  type BengProduct,
  type BengInnerPane,
  type BengShape,
  type BengSpacer,
} from "@glastotaal/core";

import { BENG_PRODUCTS as _BENG_PRODUCTS, bengSellCents as _bengSell } from "@glastotaal/core";

/** Laagste BENGglas-verkoopprijs (€/m² excl. btw, cents) over álle lijnen — de "vanaf"-prijs van
 *  de vacuümglas-landingspagina. `margins` is per lijn (BengMarginKey). null als alles op aanvraag. */
export function bengMinVanafCents(margins: Record<string, number>): number | null {
  const prices = _BENG_PRODUCTS
    .filter((p) => !p.quoteOnly && p.costPerM2Cents > 0)
    .map((p) => _bengSell(p.costPerM2Cents, margins[p.line] ?? 0));
  return prices.length ? Math.min(...prices) : null;
}
